import { useState, useEffect } from "react";

/**
 * Detects user's country/region via IP geolocation.
 * Returns region code, helper booleans, and loading state.
 *
 * Priority:
 * 1. localStorage override "userRegion" (useful for testing)
 * 2. Free IP geolocation API (https://ipapi.co/json/)
 * 3. Default fallback to "BD"
 */
const useUserRegion = () => {
  const [region, setRegion] = useState(() => {
    return localStorage.getItem("userRegion") || null;
  });
  const [loading, setLoading] = useState(!region);

  useEffect(() => {
    if (region) {
      setLoading(false);
      return;
    }

    const detectRegion = async () => {
      try {
        const res = await fetch("https://ipapi.co/json/");
        if (!res.ok) {
          throw new Error(`Region API responded with status ${res.status}`);
        }
        const data = await res.json();
        const countryCode = data?.country_code || "BD";
        setRegion(countryCode);
        localStorage.setItem("userRegion", countryCode);
      } catch (err) {
        console.warn("Region detection failed, defaulting to BD:", err);
        setRegion("BD");
      } finally {
        setLoading(false);
      }
    };

    detectRegion();
  }, [region]);

  const isBangladesh = region === "BD";
  const isUSA = region === "US";

  return { region, isBangladesh, isUSA, loading };
};

export default useUserRegion;
